import { z } from "zod";

const analyticsErrorSchema = z.object({
  data: z.object({ code: z.string() }).optional(),
});

export type AnalyticsFailureReason =
  | "authentication"
  | "validation"
  | "conflict"
  | "network"
  | "not_found"
  | "unknown";

export function analyticsFailureReason(error: unknown): AnalyticsFailureReason {
  const parsedError = analyticsErrorSchema.safeParse(error);
  if (parsedError.success && parsedError.data.data?.code === "LIST_NOT_FOUND") {
    return "not_found";
  }

  const message = error instanceof Error ? error.message.toLowerCase() : "";
  if (/auth|sign in|login/u.test(message)) return "authentication";
  if (/valid|required/u.test(message)) return "validation";
  if (/conflict|already/u.test(message)) return "conflict";
  if (/network|fetch/u.test(message)) return "network";
  return "unknown";
}
